import { useLayoutEffect, useState } from "react";
import { getCandidateToken } from "@/lib/auth";
import { getMyApplications } from "@/lib/candidate-service";

// `checking` starts true so the very first client render matches the SSR
// pass (no window/localStorage access yet) and never shows a wrong-state
// button. useLayoutEffect resolves the no-token case before paint; the
// logged-in case stays `checking` until the applications request settles.
export function useAppliedJobs() {
  const [appliedIds, setAppliedIds] = useState<Set<string>>(new Set());
  const [checking, setChecking] = useState(true);

  useLayoutEffect(() => {
    const token = getCandidateToken();
    const request = token ? getMyApplications(token) : Promise.resolve([]);
    request
      .then((apps) => setAppliedIds(new Set(apps.map((a) => a.job.job_opening_code))))
      .catch(() => {})
      .finally(() => setChecking(false));
  }, []);

  return { appliedIds, checking };
}
